import { defineStore } from "pinia";
import Services from '@/services/oldIdentificationCardServices'
import { mapOldIdentificationCard } from '@/helpers/mapFuncs'

export const useOldIdentificationCardStore = defineStore("oldIdentificationCard", {

state:()=>({
    oldIdentificationCard: {},
    oldIdentificationCards: [],
}),
getters : {
    getOldIdentificationCard() {
        return mapOldIdentificationCard(this.oldIdentificationCard)
    },
    getOldIdentificationCards() {
        return this.oldIdentificationCards.map(mapOldIdentificationCard)
    }
},
actions : {
    /** Start Sets */
    setOldIdentificationCard(oldIdentificationCard) {
        this.oldIdentificationCard = oldIdentificationCard
    },
    setOldIdentificationCards(oldIdentificationCards) {
        this.oldIdentificationCards = oldIdentificationCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setOldIdentificationCard(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setOldIdentificationCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setOldIdentificationCards(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.oldIdentificationCards.push(response.data.data)
            return mapOldIdentificationCard(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.oldIdentificationCards[this.oldIdentificationCards.findIndex((x)=>x.id == id)] = response.data.data
            return mapOldIdentificationCard(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.oldIdentificationCards = this.oldIdentificationCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});